var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ckeditor',{staticClass:"form-control",attrs:{"editor":_vm.editor,"config":_vm.editorConfig},on:{"ready":_vm.editorReady},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})}
var staticRenderFns = []

export { render, staticRenderFns }